// List of delegated tasks grouped by person.
import TaskList from '@/features/tasks/components/lists/TaskListBase';
import Panel from '@/components/ui/Panel';
import { useT } from '@/i18n/useT';

const WaitingFor = ({ delegatedTasksByPerson }) => {
  const t = useT();
  const persons = Object.keys(delegatedTasksByPerson)
    .filter((person) => (delegatedTasksByPerson[person] || []).length > 0)
    .sort((a, b) => a.localeCompare(b));

  return (
    <>
      {persons.length > 0 ? (
        persons.map((person) => {
          const tasks = delegatedTasksByPerson[person];

          return (
            <Panel key={person} flat title={person} count={tasks.length}>
              <TaskList
                tasks={tasks}
                view="plan"
                menuSurface="dashboard"
                isSortable={false}
                dragEnabled={false}
                selectedTaskIds={[]}
                onSelectionChange={() => {}}
                indentationType="none"
                showBreadcrumbs={true}
                disableStructuralNav={true}
              />
            </Panel>
          );
        })
      ) : (
        <p>
          {t(
            'dashboard.noWaiting',
            'Geen gedelegeerde taken gevonden die aan de huidige filters voldoen.',
          )}
        </p>
      )}
    </>
  );
};

export default WaitingFor;
